<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-sm-offset-3">
                <div class="alert alert-danger" role="alert" v-if="tokenError">
                    Invalid SSO!
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
    name: 'single-sign-on',
    data() {
        return {
            tokenError: false,
        };
    },
    created() {
        let token = false
        const ssoCookie = Cookies.get('connect_sso')
        if(ssoCookie) {
            token = ssoCookie.slice()
            Cookies.remove('connect_sso', { path: '/', domain: '.windhager.com' })
        } else if(this.$route.params.ssot) {
            token = this.$route.params.ssot
        }        
        if (token) {
            this.$store.dispatch('loginSSO', { authToken: token }).then(
                () => {
                    this.$router.push('/');
                },
                () => {
                    this.tokenError = true;
                }
            );
        } else {
            this.tokenError = true;
        }
    },
};
</script>
